import { Navigate, useLocation } from 'react-router-dom'

import { useAuthStore } from 'src/app/auth/interfaces'

interface ILocationState {
  from?: { pathname?: string }
}

export const RedirectIfAuthenticated = ({
  children,
}: {
  children: JSX.Element
}): JSX.Element => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)
  const location = useLocation()

  if (isAuthenticated()) {
    const state = location.state as ILocationState | null
    const fromPath = state?.from?.pathname ?? '/'
    return <Navigate to={fromPath} replace />
  }
  return children
}
